import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import editIcon from '../../../images/icons/edit.svg';
import deleteIcon from '../../../images/icons/delete.svg';
import AlertModal from '../../Common/AlertModal/AlertModal';
import Message from '../../Common/Message/Message';
import Help from '../../Common/Help/Help';


const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class ManageUsers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            users: [],
            isModalOpen: false,
            targetUserId: null,
            message: {
                title: '',
                content: '',
                type: ''
            },
            videos: [],
        }
    }

	getAdminVideos = () => {
        const getVideos = async () => {
            try {
                const videosResponse = await getVideosAPI();
                console.log('videosResponse: ', videosResponse);
                if (videosResponse.data) {
                    const videos = videosResponse.data;
                    this.setState({
                        videos,
                    });
                }
            } catch (error) {
                console.log('error', error);
            }
        };

        async function getVideosAPI() {
            return await ApiRequest('/admin/videos', {
                method: 'GET',
            });
        }
        getVideos();
    }

    setMessage = (title, content, type) => {
        const message = { ...this.state.message };
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    toggleAlertModal = (e) => {
        const targetUserId = e.target.id;
        this.setState({
            isModalOpen: !this.state.isModalOpen,
            targetUserId
        });
    }

    confirmAlertModal = () => {
        this.removeUser(this.state.targetUserId);
        this.setState({
            isModalOpen: false,
            targetUserId: null
        });
    }

    removeUser = (id) => {
        this.setMessage('', '', 'loading');
        (async() => {
            try {
                const response = await deleteUser();
                if (response.data.error) {
                    this.setMessage(window.general_strings.msg.oops, response.data.error.code, 'error');
                } else {
                    const users = [...this.state.users];
                    users.forEach((user, i) => {
                        if (user.id === parseInt(id, 0)) {
                            users.splice(i, 1);
                        }
                    })
                    this.setState({ users }, () => this.setMessage('', '', '')); 
                    console.log('Delete user: ', response);
                }
            } catch (error) {
                this.setMessage(window.general_strings.msg.oops, error, 'error');
            }
        })()

        async function deleteUser() {
            return await ApiRequest(`/users/${id}`, {
                method: 'delete'
            });
        }
    }

    componentDidMount() {
        (async () => {
            try {
                const response = await getUsers();
                console.log('Current Client Users: ', response);
                if (response.data.error) {
                    this.setMessage(window.general_strings.msg.oops, response.data.error.code, 'error');
                } else {
                    this.setState({ users: response.data.users });
                }
            } catch (error) {
                this.setMessage(window.general_strings.msg.oops, error, 'error');
            }
        })()

        async function getUsers() {
            return await ApiRequest('/users');
        }

        this.getAdminVideos();
    }

    render() { 
        const videos = this.state.videos;
		let videoUrl = 'https://www.youtube.com/channel/UC30U07xVY2zbooskb9VpRzg/videos';
        videos.forEach((video) => {
            if (video.title.includes('Client Prefs:Users')) {
                videoUrl = `https://www.youtube.com/watch?v=${video.youtube_id}`;
			}
        });
        return ( 
            <React.Fragment>
                <AlertModal
                    isModalOpen={this.state.isModalOpen}
                    toggleAlertModal={this.toggleAlertModal}
                    confirmAlertModal={this.confirmAlertModal}
                    modalTitle={strings.modalTitle}
                    modalDescription={strings.modalDescription}
                />
                <div className="container">
                    <Message
                        message={this.state.message}
                    />
                </div>
                <div className="showtix-section">
                    <div className="container">
                        <h1>{strings.title}</h1>
                        <div className="row">
                            <div className="col-12 col-lg-8 text-left">
                                <div className="showtix-form__group">
                                    <div className="table-responsive">
                                        <table className="showtix-table showtix-table__striped">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: 50 }}></th>
                                                    <th>{strings.user}</th>
                                                    <th>{strings.email}</th>
                                                    <th>{strings.role}</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.users.map((user, i) => {
                                                        let isSameUser = this.props.user.id === user.id;
                                                        return (
                                                            <tr key={i}>
                                                                <td className="text-left">
                                                                    {user.role !== 'admin' &&
                                                                        <Link to={{ 
                                                                            pathname: `/create-user/${user.id}`
                                                                        }}>
                                                                            <img className="edit-icon" src={editIcon} alt="edit icon" />
                                                                        </Link>
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {user.first_name} {user.last_name} {!user.active && <span className="showtix-badge warning" >Inactive</span>}
                                                                </td>
                                                                <td>
                                                                    {user.email}
                                                                </td>
                                                                <td>
                                                                    {user.role}
                                                                </td>
                                                                <td className="text-right">
                                                                    {!isSameUser &&
                                                                    <img
                                                                        id={user.id}
                                                                        className="delete-icon"
                                                                        src={deleteIcon}
                                                                        alt="delete icon"
                                                                        onClick={(e) => this.toggleAlertModal(e)}
                                                                    />
                                                                    }
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            { strings.helps &&
                            <div className="col-12 col-lg-4">
                                <div className="showtix-box">
									<div className="showtix-padder">
										<h3 className="showtix-box__title">{strings.video.title}</h3>
										<p><a href={videoUrl} target="_blank" rel="noopener">{strings.video.content1}</a></p>
									</div>	
								</div>
                                {strings.helps.map((help, i) =>
                                    <Help help={help} key={i} />
                                )}
                            </div>
                            }
                        </div>
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <div className="showtix-form__group">
                                    <Link to="/create-user">
                                        <button 
                                            type="button"
                                            className="showtix-button showtix-background__primary-1">
                                            <span>{strings.addNewUser}</span>
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
         )
    }
}
 
export default ManageUsers;


// WEBPACK FOOTER //
// ./src/components/ClientPreferences/ManageUsers/ManageUsers.js